<template>
  <div>
    <div class="embed-responsive embed-responsive-16by9">
      <div class="player embed-responsive-item mt-2" ref="vidBox"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "playerComponent",
  props: ["id", "type"],
  mounted() {
    // Initialize once the element exists
    this.initialize();
  },
  methods: {
    initialize() {
      const target = this.$refs.vidBox;
      if (!target || !this.id) return;
      this.initializePlayer(this.id, target, this.type);
    },
  },
  watch: {
    id: function(newVal) {
      const target = this.$refs.vidBox;
      if (!target || !newVal) return;
      this.initializePlayer(newVal, target, this.type);
    },
  },
};
</script>

<style></style>
